// extracted by mini-css-extract-plugin
export var quillEditor = "_jd-1";
export var variable = "_jd-0";